import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import type { User } from '@socialmanagement/types'

export function AdminRoute() {
  const user = useAuthStore((s) => s.user) as User | null

  if (!user || (user.role !== 'admin' && user.role !== 'superadmin')) {
    return <Navigate to="/app" replace />
  }

  return <Outlet />
}
